module.exports = __webpack_public_path__ + "static/computer-5d9c0705018a5bfb949ae1b99b06c443.png";